import * as React from 'react';
import style from './FeedbackButton.scss';
import { SIZES, Text } from '../../PageElements/Text';
import classNames from 'classnames';
import { Box } from 'wix-style-react';
import { HappyFaceSmallIcon, SadFaceSmallIcon } from '../../PageElements/svgs';
import { Button } from '../../Layout/Button';

interface FeedbackButtonProps {
  onLikeClick: () => void;
  onUnlikeClick: () => void;
  submittedLike: boolean;
  submittedUnlike: boolean;
}

export const FeedbackButton = ({
  onLikeClick,
  onUnlikeClick,
  submittedLike,
  submittedUnlike,
}: FeedbackButtonProps) => {
  return (
    <div data-hook="feedback" className={style.wrapper}>
      <Box marginRight="6px">
        <Text size={SIZES.small} secondary>
          Was this helpful?
        </Text>
      </Box>
      <Box marginRight="8px">
        <Button
          dataHook="feedbackLikeBtn"
          className={classNames(style.likeBtn, {
            [style.selected]: submittedLike,
          })}
          onClick={onLikeClick}
          skin="secondary"
          size="tiny"
        >
          <Box marginRight="2px">
            <HappyFaceSmallIcon size="14px" />
          </Box>
          Yes
        </Button>
        <Button
          dataHook="feedbackUnlikeBtn"
          className={classNames(style.unlikeBtn, {
            [style.selected]: submittedUnlike,
          })}
          onClick={onUnlikeClick}
          skin="secondary"
          size="tiny"
        >
          <Box marginRight="2px">
            <SadFaceSmallIcon size="14px" />
          </Box>
          No
        </Button>
      </Box>
    </div>
  );
};
